export function validatePinPolicy(settings) {
    if (typeof settings?.enabled !== 'boolean') throw new Error('PIN 정책을 확인하지 못했습니다.');
    if (!settings.enabled) return settings;
    if (typeof settings.policy_version !== 'string' || !Number.isInteger(settings.version)) throw new Error('PIN 정책 버전을 확인하지 못했습니다.');
    for (const purpose of ['login', 'withdraw']) {
        const policy = settings[purpose];
        if (typeof policy?.required !== 'boolean' || (policy.required && (policy.method !== 'PIN' || !Array.isArray(policy.allowed) || policy.allowed.length !== 1 || policy.allowed[0] !== 'PIN'))) {
            throw new Error('PIN 전용 정책이 아닙니다. 관리자에게 문의해주세요.');
        }
    }
    return settings;
}
export function newPinError(pin, repeat) {
    if (!/^[0-9]{4}$/.test(pin) || pin !== repeat) return '새 PIN 4자리와 확인 값이 일치해야 합니다.';
    if (/^(\d)\1{3}$/.test(pin) || '0123456789'.includes(pin) || '9876543210'.includes(pin)) return '반복되거나 연속된 PIN은 사용할 수 없습니다.';
    return '';
}
export function pinCredentials({ settings, password, pin, repeat, management, recovery }) {
    const error = newPinError(pin, repeat);
    if (error) throw new Error(error);
    if (!password) throw new Error('현재 로그인 비밀번호를 입력해주세요.');
    const body = { password, pin, expected_version: settings.version };
    if (settings.recovery_required) {
        if (!recovery?.trim()) throw new Error('본인 확인 후 전달받은 복구 권한을 입력해주세요.');
        body.recovery_authorization = recovery.trim();
    } else if (settings.pin_registered) {
        if (!management?.value || management.expiresAt <= Date.now()) throw new Error('기존 PIN을 다시 인증해주세요.');
        body.management_authorization = management.value;
    }
    return body;
}
